import { Component, type ReactNode } from 'react';

type State = { err: Error | null };
type Props = { children: ReactNode; fallback?: (err: Error, reset: () => void) => ReactNode };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: any) {
    // eslint-disable-next-line no-console
    console.error('FiberForge ErrorBoundary caught:', err, info);
  }

  reset = () => this.setState({ err: null });

  render() {
    if (this.state.err) {
      if (this.props.fallback) return this.props.fallback(this.state.err, this.reset);
      return (
        <div style={{ padding: 24 }}>
          <div style={{
            background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca',
            padding: 16, borderRadius: 8, maxWidth: 720, margin: '20px auto',
          }}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Something broke in the map view.</div>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, margin: 0 }}>{String(this.state.err?.stack ?? this.state.err?.message ?? this.state.err)}</pre>
            <button onClick={this.reset} className="btn" style={{ marginTop: 10 }}>Try again</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
